import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { Row, Col } from 'reactstrap';
import SunEditor from 'suneditor-react';

import ErrorFeedback from '@shared/components/error-feedback/ErrorFeedBack';

type CustomWysiwygProps = {
  content: any;
  inputChange: (e: any) => void;
  errors?: any;
  placeholder?: any;
  maxLength?: any;
  readOnly?: boolean;
  hideToolbar?: boolean;
  height?: string;
  setOptions?: any;
  handleFocus?: () => void;
  style?: string;
  [key: string]: any;
};

const getTextContent = (html: string): string => {
  if (isEmpty(html)) return '';
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || '';
  return text.trim();
};

const CustomWysiwyg = ({
  content,
  inputChange,
  errors,
  placeholder,
  maxLength = 0,
  readOnly = false,
  hideToolbar = true,
  height = '150',
  setOptions,
  handleFocus = () => { },
  style = '',
  ...rest
}: CustomWysiwygProps) => {
  const sanitizedContent = getTextContent(content);

  return (
    <>
      <div
        className={classNames('editor-container', {
          'sun-editor-error': errors || (maxLength > 0 && sanitizedContent.length > maxLength),
        })}
      >
        <SunEditor
          setDefaultStyle={`font-family: Serif; font-size: 16px; ${style}`}
          height={height}
          setContents={content || ''}
          onChange={value => inputChange(value)}
          hideToolbar={hideToolbar}
          placeholder={placeholder}
          readOnly={readOnly}
          setOptions={setOptions}
          onFocus={handleFocus}
          {...rest}
        />
      </div>
      <ErrorFeedback formError={errors} />
      {maxLength > 0 && (
        <Row className="mb-3">
          <Col className="text-end">
            <span className="text-limit-indicator">
              <span className={classNames('', {
                'text-limit-indicator-error': sanitizedContent.length > maxLength,
              })}
              >
                {sanitizedContent.length || 0}
              </span>
              <span>/{maxLength}</span>
            </span>
          </Col>
        </Row>
      )}
    </>
  );
};

export default CustomWysiwyg;
